import { ChemicalLabel } from '../data-models/chemical-label.model';
import { isRecord } from './is-record';
import { nullableString } from './wire-value-utils';

/** A chemical's current EPA labels as sent (rows without a URL dropped), `null` when the hub sent `null`, otherwise `undefined`. */
export function chemicalLabels(value: unknown): ChemicalLabel[] | null | undefined {
  if (!Array.isArray(value)) {
    return value === null ? null : undefined;
  }
  return value
    .filter(isRecord)
    .map(label => ({ url: nullableString(label['url']) ?? '', name: nullableString(label['name']) ?? null }))
    .filter(label => label.url !== '');
}
